import { isEmpty } from "lodash";
import moment from "moment";
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthProvider from "../context/AuthContext";
import BetSlipContext from "../context/BetSlipContext";
import { apiGet, apiGet2 } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import helpers from "../Utils/helpers";
import LayoutComponent from "../components/shared/Layout";
import MatchDetailsHome from "./MatchDetails/MatchDetailsHome";
import { getData, setData } from "../Utils/indexedDB";

function Sports() {
  let { handelAddMultiMarket } = useContext(BetSlipContext);
  const sportsDataRef = useRef([]);
  const pollingRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [sportsData, setSportsData] = useState([]);
  
  let {
    user,
    setSearchToogle,
    setLoader,
    setCasinoModel,
    setCasinoObj,
    profileData, 
    launchCasino,
    inPlayScore // Assuming this is available from AuthContext
  } = useContext(AuthProvider);
  const [centralizedIds, setCentralizedIds] = useState([]);
  const [inplayCountData, setInplayCountData] = useState({});

  const SPORT_TYPES = {
    cricket: 4,
    soccer: 1,
    tennis: 2,
  };
  const [sports, setSport] = useState("cricket");
  const sportsRef = useRef(sports);

  useEffect(() => {
    sportsRef.current = sports; // always keep latest
    const loadFromDB = async () => {
      // setLoader(true);

      const stored = await getData("sportsData");

      if (stored?.status) {
        appendData(SPORT_TYPES[sportsRef.current?.toLowerCase()], stored);
      }
    };

    loadFromDB();
  }, [sports]);

  const transformMatchListData = (newData) => {
    if (!newData) {
      return null;
    }

    // Filter out matches with negative id or eventId
    const matches = newData

    const transformedResults = matches.map(match => {
      // Get the primary market for this match
      const primaryMarket = match.market || (match.markets && match.markets.length > 0 ? match.markets[0] : null);

      // Extract runners from the primary market
      const runners = primaryMarket && primaryMarket.selections ?
        primaryMarket.selections.map(selection => ({
          SelectionId: selection.selectionId,
          RunnerName: selection.runnerName
        })) : [];

      // Create an empty matchOdds array as in old format
      const matchOdds = [];

      // Determine status based on secondsToStart - if 0 then in_play, otherwise upcoming
      // const status = match.secondsToStart === 0 ? 'in_play' : 'upcoming';
      const status = match.isInPlay === 1 ? 'in_play' : 'upcoming';

      // Generate centralized ID from primary market ID
      const centralizedId = primaryMarket ? primaryMarket.marketId : match.id.toString();
      // console.log(match)
      return {
        hasFancy: match.hasFancyBetMarkets || false,
        hasBookmaker: match.hasBookMakerMarkets || false,
        _id: match.id.toString(), // Convert to string as in old format
        gameType: sportsRef.current, // Use the dynamic sport type instead of hardcoded "cricket"
        tournamentId: null, // Not available in new format
        seriesId: match.competitionId.toString(),
        eventId: match.eventId.toString(),
        marketId: centralizedId,
        centralizedId: centralizedId,
        match: "on", // Assuming always on as in old format
        matchOdds: "on", // Always on
        premiumFancy: (match.hasSportsBookMarkets || match.hasOwSportsBookMarkets || match.hasGeniusSportsMarkets) ? "on" : "off",
        bookMaker: (match.hasBookMakerMarkets || match.hasInPlayBookMakerMarkets) ? "on" : "off",
        fancy: (match.hasFancyBetMarkMarkets || match.hasInPlayFancyBetMarkets) ? "on" : "off", // Note: Fixed typo 'hasFancyBetMarkMarkets'
        eventName: match.name,
        venue: null, // Not available in new format
        timeZone: match.timezone || "Europe/London",
        eventDateTime: new Date(match.openDateTime).toISOString(),
        marketCount: match.markets ? match.markets.length : 0,
        runners: runners,
        bookmakerRunners: runners, // Same as runners for now
        status: status,
        eventType: match.eventType.toString(),
        seriesName: match.competitionName,
        matchSetting: [],
        matchOdss: matchOdds // Empty array as in old format
      };
    });

    return {
      success: newData.status,
      message: newData.message,
      results: transformedResults
    };
  };

  const getTournamentData = async (isLoader = true) => {
    // if (isLoader) {
    //   setLoader(true);
    // }
    const currentSports = SPORT_TYPES[sportsRef.current?.toLowerCase()];

    // ✅ 1. Load from IndexedDB FIRST
    const storedData = await getData("sportsData");

    if (storedData) {
      try {
        if (storedData?.status) {
          setLoader(false);
          setLoading(false);
          appendData(currentSports, storedData); // 🔥 instant UI
        }
      } catch (e) {
        console.error("Invalid localStorage data");
      }
    }

    // ✅ 2. Call API in background
    try {
      const { status, data: response_users } = await apiGet(
        apiPath.matchList + `?game_type=all`
      );

      if (status === 200 && response_users.status) {
        // ✅ 3. Save in IndexedDB
        await setData("sportsData", response_users);
        
        // ✅ 4. Update UI with fresh data
        appendData(currentSports, response_users);
      }
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
    setLoader(false);
  };
  const appendData = (currentSports, storedData) => {
    
    const matches = storedData?.data?.matches || [];

    // ✅ filter by type
    let filteredMatches =
      currentSports && currentSports !== "all"
        ? matches.filter((m) => m.eventType === currentSports)
        : matches;
    // Transform new data format to old format
    const transformedData = transformMatchListData(filteredMatches);
    let newData = transformedData.results || [];

    // Sort matches by eventDateTime, but push Virtual competitions to the bottom
    newData = newData.sort((a, b) => {
      const aVirtual = a.seriesName?.toLowerCase().includes("virtual");
      const bVirtual = b.seriesName?.toLowerCase().includes("virtual");

      if (aVirtual !== bVirtual) return aVirtual ? 1 : -1;
      
      return new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime();
    });

    setLoader(false);
    
    // Preserve existing match odds data when updating
    setSportsData((prevData = []) => {
      const prevMap = new Map(
        prevData.map((item) => [String(item.eventId), item])
      );

      return newData.map((item) => {
        const existing = prevMap.get(String(item.eventId));

        return existing
          ? {
              ...item,
              back_odds: existing.back_odds,
              lay_odds: existing.lay_odds,
              totalMatched: existing.totalMatched,
              matchOddsData: existing.matchOddsData,
            }
          : item;
      });
    });
    
    const marketIds = newData.map((r) => r.centralizedId).filter(Boolean);
    if (marketIds && marketIds.length) {
      setCentralizedIds(marketIds);
    }
  }

  const inPlayCount = async () => {
    const { status, data: response_users } = await apiGet(apiPath.inPlayCount+"?type=in_play");
    if (status === 200) {
      if (response_users.status) {
        if (response_users.data) {
          setInplayCountData(response_users.data);
        }
      }
    }
  };

  const transformMatchDataToOldFormat = (newData) => {
    if (!newData || !newData.data || !Array.isArray(newData.data)) {
      return null;
    }

    // Transform all market data entries, not just the first one
    const transformedMarkets = newData.data.map(marketData => {
      const msValue = marketData.status === "OPEN" ? 1 : marketData.status === "SUSPENDED" ? 3 : 1;

      const runners = marketData.selections.map(selection => ({
        selectionId: selection.selectionId,
        handicap: selection.handicap,
        status: selection.status,
        lastPriceTraded: selection.lastPriceTraded,
        totalMatched: selection.totalMatched,
        adjustmentFactor: 0,
        ex: {
          availableToBack: selection.availableToBack.length > 0
            ? selection.availableToBack
            : [{ price: 0, size: 0 }, { price: 0, size: 0 }, { price: 0, size: 0 }],
          availableToLay: selection.availableToLay.length > 0
            ? selection.availableToLay
            : [{ price: 0, size: 0 }, { price: 0, size: 0 }, { price: 0, size: 0 }]
        }
      }));

      let rt = [];

      marketData.selections.forEach(selection => {
        if (selection.availableToBack && selection.availableToBack.length > 0) {
          selection.availableToBack.forEach(back => {
            rt.push({
              ri: selection.selectionId,
              rt: back.price,
              bv: back.size,
              ib: true
            });
          });
        } else {
          for (let i = 0; i < 3; i++) {
            rt.push({
              ri: selection.selectionId,
              rt: 0,
              bv: 0,
              ib: true
            });
          }
        }

        if (selection.availableToLay && selection.availableToLay.length > 0) {
          selection.availableToLay.forEach(lay => {
            rt.push({
              ri: selection.selectionId,
              rt: lay.price,
              bv: lay.size,
              ib: false
            });
          });
        } else {
          for (let i = 0; i < 3; i++) {
            rt.push({
              ri: selection.selectionId,
              rt: 0,
              bv: 0,
              ib: false
            });
          }
        }
      });

      return {
        mi: marketData.marketId,
        ms: msValue,
        totalMatched: marketData.totalMatched,
        rt: rt,
        runners: runners,
        lastMatchTime: marketData.lastMatchTime,
        ts: new Date().toISOString().replace('T', ' ').substring(0, 19),
        eventId: marketData.eventId
      };
    });

    return {
      success: newData.status,
      message: newData.message,
      results: transformedMarkets
    };
  };

  const getMatchOdds = async (eventIds) => {
    if (!eventIds || eventIds.length === 0) return;
    
    try {
      const { status, data: response } = await apiGet2(
        apiPath.getMatchOdds + `?match_ids=${eventIds.join(",")}`
      );

      if (status === 200 && response.status) {
        const transformedData = transformMatchDataToOldFormat(response);
        if (transformedData && Array.isArray(transformedData.results)) {
          // transformedData.results is now an array of market data for multiple events
          setSportsData((current) =>
            current?.map((obj) => {
              // Find the matching market data for this event
              const socket_data = transformedData.results.find(
                (market) => String(market.eventId) === String(obj.eventId)
              );
              
              if (socket_data) {
                const back_odds = socket_data?.rt?.filter((rt) => rt.ib) || [];
                const lay_odds = socket_data?.rt?.filter((rt) => !rt.ib) || [];
                return { 
                  ...obj, 
                  back_odds,
                  lay_odds,
                  totalMatched: socket_data?.totalMatched,
                  matchOddsData: socket_data
                };
              }
              return obj;
            })
          );
        }
      }
    } catch (error) {
      console.error("Error fetching match odds:", error);
    }
  };

  useEffect(() => {
    sportsDataRef.current = sportsData;
  }, [sportsData]);

  // Update sports data with score from context (similar to the reference component)
  useEffect(() => {
    if (!inPlayScore?.length) return;

    // ✅ Convert score array to Map (O(n))
    const scoreMap = new Map(
      inPlayScore.map((item) => [String(item.eventId), item])
    );

    setSportsData((current = []) =>
      current.map((res) => {
        const temp = scoreMap.get(String(res.eventId));

        if (!temp) return res;

        return {
          ...res,
          score: temp.current_score || "",
          timeElapsed: temp.timeElapsed || "",
        };
      })
    );
  }, [inPlayScore]); // Added sportsData as dependency to ensure update when data changes


  useEffect(() => {
    inPlayCount();
  }, []);

  useEffect(() => {
    let isFetching = false;

    const callApi = async () => {
      if (isFetching || document.hidden) return; // ✅ prevent duplicate calls

      isFetching = true;
      await getTournamentData(false);
      isFetching = false;
    };

    callApi(); // ✅ immediate first call

    const interval = setInterval(callApi, 60000); // every 1 min

    return () => clearInterval(interval); // ✅ cleanup
  }, []);
  // Polling for match odds - runs every 5 seconds
  const hasDataRef = useRef(false);

  useEffect(() => {
    const poll = () => {
      const currentData = sportsDataRef.current;

      if (!currentData || currentData.length === 0) return;

      const eventIds = currentData
        .map((item) => item.eventId)
        .filter(Boolean);

      if (eventIds.length > 0) {
        getMatchOdds(eventIds);
      }
    };

    // run immediately when sportsData first becomes available
    if (sportsData && sportsData.length > 0 && !hasDataRef.current) {
      hasDataRef.current = true;
      poll();
    }

    // start interval only once
    if (!pollingRef.current) {
      pollingRef.current = setInterval(poll, 5000);
    }

    return () => {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    };
  }, [sportsData]);

  return (
    <LayoutComponent visibilityType={true}>
    <>
      {/* <a href="javascript:void(0)">
        <img
          src={
            import.meta.env.VITE_IMAGE_URL +
            "/assets/images/Slider-3.webp"
          }
          style={{ width: "100%" }}
        />
      </a> */}
      <div className="mian-wrap">
        <div id="highlightLabel" className="highlight-fix" style={{paddingTop:"12.7vw"}}>
          <a
            className="a-search"
            onClick={() => setSearchToogle(true)}
            href="javascript:void(0)"
          >
            Search
          </a>
          <div
            id="frame"
            className="wrap-highlight ps ps--theme_default ps--active-x"
            style={{ overflow: "auto" }}
          >
            <ul id="label" style={{ left: "0px", marginBottom:"0", paddingLeft: "0" }}>
            
            <li className="menu-casino">
                  <span className="tag-new">New</span>
                  <a
                    onClick={() => {
                      if (!isEmpty(user)) {

                        launchCasino({
                          platForm: "1",
                          gameType: "",
                          casinoType: "",
                        });
                      } else {
                        navigate("/login");
                      }
                    }}
                    href="javascript:void(0)"
                  >
                    <img
                      className="icon-casino"
                      src={
                        "/assets/images/home/transparent.gif"
                      }
                    />
                    
                  </a>
                  <span>Casino</span>
                </li>
              

                <li
                id="highlightTab4"
                className={sports == "cricket" ? "select" : ""}
              >
                <span id="tagLive" className="tag-live">
                  <strong></strong>
                  {inplayCountData?.cricketInplayCount}
                </span>
                <a
                  href="javascript:void(0)"
                  onClick={() => setSport("cricket")}
                  className="icon-cricket"
                >
                  <img
                    
                    src={
                      "/assets/images/tab-cricket.svg"
                    }
                  />
                  
                </a>
                <span>Cricket</span>
              </li>

              <li
                id="highlightTab1"
                className={sports == "soccer" ? "select" : ""}
              >
                <span id="tagLive" className="tag-live">
                  <strong></strong> {inplayCountData?.soccerInplayCount}
                </span>
                <a href="javascript:void(0)" onClick={() => setSport("soccer")} className="icon-soccer">
                  <img
                    
                    src={
                      "/assets/images/tab-soccer.svg"
                    }
                  />
                  
                </a>
                <span>Soccer</span>
              </li>

              <li
                id="highlightTab2"
                className={sports == "tennis" ? "select" : ""}
              >
                <span id="tagLive" className="tag-live">
                  <strong></strong> {inplayCountData?.tennisInplayCount}
                </span>
                <a href="javascript:void(0)" onClick={() => setSport("tennis")} className="icon-tennis">
                  <img
                    
                    src={
                      "/assets/images/tab-tennis.svg"
                    }
                  />
                  
                </a>
                <span>Tennis</span>
              </li>
              {/* {!isEmpty(user) && (
                <li className="menu-casino">
                  <a
                    onClick={() => {
                      if (!isEmpty(user)) {
                        setCasinoModel(true);
                        setCasinoObj({
                          platForm: "",
                          gameType: "international",
                          casinoType: "livecasino",
                        });
                      } else {
                        navigate("/login");
                      }
                    }}
                    href="javascript:void(0)"
                  >
                    <img
                      className="icon-casino"
                      src={
                        import.meta.env.VITE_IMAGE_URL +
                        "/assets/images/home/transparent.gif"
                      }
                    />
                    International Casino
                  </a>
                </li>
              )} */}
              {/* <li id="highlightTab137">
                <span id="tagLive" className="tag-live">
                  <strong></strong>2
                </span>
                <a href="#">
                  <img
                    className="icon-esoccer"
                    src="assets/images/home/transparent.gif"
                  />
                  E-Soccer
                </a>
              </li> */}
              {/* <li>
                <a href="#">
                  <img
                    className="icon-mt5"
                    src="assets/images/home/transparent.gif"
                  />
                  Sky Trader
                </a>
              </li> */}

              {/* <li id="highlightTab7">
                <a href="#">
                  <img
                    className="icon-HR"
                    src="assets/images/home/transparent.gif"
                  />
                  Horse Racing
                </a>
              </li> */}
            </ul>
          </div>
        </div>

        <div className="wrap-highlight_list">
          <h3 style={{color:"white", lineHeight:"2", fontSize:"18px"}}>Highlights</h3>
          {/* {sports == "cricket" ? (
          <div className="game_ban">
            <img
              src={
                import.meta.env.VITE_IMAGE_URL +
                "/assets/images/home/cricketnewbanner.webp"
              }
              alt=""
            />
          </div>
        ) : sports == "tennis" ? (
          <div className="game_ban">
            <img
              src={
                import.meta.env.VITE_IMAGE_URL +
                "/assets/images/home/tennisnewbanner.webp"
              }
              alt=""
            />
          </div>
        ) : (
          sports == "soccer" && (
            <div className="game_ban">
              <img
                src={
                  import.meta.env.VITE_IMAGE_URL +
                  "/assets/images/home/soccernewbanner.webp"
                }
                alt=""
              />
            </div>
          )
        )} */}
          <ul id="highlightList" className="highlight-list">
            <li id="noDatali" style={{ display: "none" }}>
              There are no events to be displayed.
            </li>
            {sportsData &&
              sportsData?.map((item) => {
                let obj = moment.duration(
                  moment(item.eventDateTime).diff(moment(new Date()))
                )._data;
                return (
                  <>
                    <li
                      id="highlightEvent_-10362833"
                      className={`inplay-on ${item?.status == "in_play"
                        ? "inplay-dot-true"
                        : "inplay-dot-false"
                        }`}
                    >
                      <Link
                        id="info"
                        state={item}
                        to={`/match-details/${item?.eventId}/${item?.marketId}`}
                      >
                        {
                        item?.gameType==="cricket" &&
                          <img
                          src= {item?.channel !== "false"? "/assets/images/cricket-live-icon.png":"/assets/images/cricket-off-icon.png"}
                          className="list-image"
                        />
                      }
                      {
                        item?.gameType==="soccer" &&
                        <img
                        src= {item?.channel !== "false"? "/assets/images/soccer-live-icon.png":"/assets/images/soccer-off-icon.png"}
                        className="list-image"
                      />
                      }
                      {
                        item?.gameType==="tennis"&&
                        <img
                        src= {item?.channel !== "false"? "/assets/images/tennis-live-icon.png":"/assets/images/tennis-off-icon.png"}
                        className="list-image t4"
                      />
                      }
                        <dl>
                          <dt>
                          {item?.channel !== "false" && (
                            <span
                              id="streamingIcon"
                              className="game-live"
                              style={{ display: "flex" }}
                            >
                              game-live
                            </span>
                          )} 
                            {/* <span
                              id="lowLiquidityTag"
                              className="game-low_liq"
                              style={{ display: "none" }}
                            >
                              Low Liquidity
                            </span> */}
                            {/* <span
                              id="bookMakerIcon"
                              className={`game-bookmaker game-odds ${"in-play"}`}
                              style={{ display: "flex" }}
                            >
                              {<pre>in-play</pre>} Odds
                            </span> */}
                            {/* {console.log(sportsData)} */}
                            {/* {item?.gameType == "cricket" && item?.bookmakerMarketId && */}
                              {/* <> */}

                            {item?.bookMaker === "on" && 
                              <span
                                id="bookMakerIcon"
                                className={`game-bookmaker ${"in-play"}`}
                                style={{ display: "flex" }}
                              >
                                {<pre>in-play</pre>} BookMaker
                              </span>
                            }

                            {item?.fancy === "on" && 
                              <span
                                id="fancyBetIcon"
                                className={`game-fancy ${"in-play"
                                  }`}
                                style={{ display: "flex" }}
                              >
                                {<pre>in-play</pre>} Fancy
                              </span>
                            }
                            
                            {item?.premiumFancy === "on" && 
                              <span
                                id="feedingSiteIcon"
                                className={`game-sportsbook`}
                                style={{ display: "flex" }}
                              >
                                Sportsbook
                              </span>
                            }
                            {obj.days == 0 &&
                              obj.hours == 0 &&
                              obj?.years == 0 &&
                              obj?.months == 0 &&
                              obj.minutes > 0 &&
                              obj?.minutes < profileData?.beforeInPlay ? (
                              <span id="dateTimeInfo" className="time">
                                Starting in {obj?.minutes}'
                              </span>
                            ) : item.status == "in_play" ? (
                              <span id="dateTimeInfo" className="time">
                                In-Play 
                              </span>
                            ) : (
                              <span id="dateTimeInfo" className="time">
                                {helpers.matchDateTime(item.eventDateTime)}
                              </span>
                            )}

                          </dt>
                          {/* {console.log(item?.eventName)} */}
                          <dd id="eventName">
                            {" "}
                            {(() => {
                              // Split on " v " (case-insensitive) to handle team names with "/" or other characters
                              const parts = item?.eventName?.split(/\s+v\s+/i);
                              const team1 = parts?.[0] || item?.eventName;
                              const team2 = parts?.[1] || "";
                              
                              // Display score if available
                              if (item?.score) {
                                return (
                                  <>
                                    {team1}
                                    <span style={{ color: '#e4550f', fontWeight: "700" }}>
                                      {" " + (item?.score?.split(" || ")[0] || item?.score) + " "}
                                    </span>
                                    {team2}
                                  </>
                                );
                              } else {
                                // Default display without score
                                return team2 ? (
                                  <>
                                    {team1}
                                    <span style={{ color: "#508d0e", fontWeight: "700" }}> v </span>
                                    {team2}
                                  </>
                                ) : (
                                  item?.eventName
                                );
                              }
                            })()}
                            {/* {item?.score ? (
                              <>
                                {item?.eventName.split("v")[0]}
                                <span style={{ color: "#508d0e", fontWeight: "700" }}> V </span>
                                {item?.eventName.split("v")[1]}
                              </>
                            ) : (
                              <>
                                {item?.eventName.split("v")[0]}
                                <span style={{ color: "#508d0e", fontWeight: "700" }}> V </span>
                                {item?.eventName.split("v")[1]}

                              </>


                            )} */}

                            {/* // {item?.score ? `${item?.eventName.split("v")[0]} ${item?.score
                            //   } ${item?.eventName.split("v")[1]}`
                            //   : item?.eventName} */}
                          </dd>
                        </dl>
                      </Link>
                      <a
                        id="multiMarketPin"
                        // className="pin-off"
                        onClick={() => {
                          if (!isEmpty(user)) {
                            handelAddMultiMarket(item?.eventId);
                            setLoading(true);
                          } else {
                            navigate("/login");
                          }
                        }}
                        className={item.multi_market > 0 ? "pin-on" : "pin-off"}
                        href="javascript:void(0)"
                      ></a>
                      {/* <Link
                        className={
                          item.multiMarket ? "add-pin-position" : "add-pin"
                        }
                        onClick={() => handelAddMultiMarket(item.eventId)}
                      ></Link> */}
                      
                    </li>
                    {item?.back_odds && item?.back_odds?.length > 0 && (
                        <MatchDetailsHome
                          selections={item?.runners || []}
                          back_odds={item?.back_odds || []}
                          lay_odds={item?.lay_odds || []}
                          details={item}
                          totalMatched={item?.totalMatched || 0}
                          setSlipObj={() => {}}
                          setSelections={() => {}}
                          slipObj={{}}
                          handelBetFairPositions={() => {}}
                          resetSelection={() => {}}
                          setCondi={() => {}}
                          betType="betFair"
                          profileData={profileData}
                          user={user}
                          messaageBox={null}
                          betFairMs={item?.matchOddsData?.ms || 1}
                          setMarketDepth={() => {}}
                          marketId={item?.marketId}
                          marketName="Match Odds"
                        />
                    )}
                  </>
                );
              })}
          </ul>
        </div>
        <div class="footer-kv">
          <a class="entrance" 
          onClick={() => {
            if (!isEmpty(user)) {
              launchCasino({
                platForm: "SABA",
                gameType: "VIRTUAL",
                casinoType: "SABA-VIRTUAL-001",
              });
            } else {
              navigate("/login");
            }
          }}>
            <img
              src={"/assets/images/kv-virtual-cricket-m.jpg"}
              style={{ width: "100%" }}
              alt=""
            />
          </a>
        </div>
        {/* <div class="footer-kv">
          <a class="entrance" href="#">
            <img
              src={"/assets/images/home/kv-virtual-cricket-m.jpg"}
              style={{ width: "100%" }}
              alt=""
            />
          </a>
        </div>
        <h3 id="nextHeader">Next Horse Race</h3>
        <ul id="nextUpComing" class="upcoming-list">
          <li>
            <a href="/sportsdetail">
              <span class="time">R11 2150m Trot M</span>16:59 Bendigo(AUS)
            </a>
          </li>
          <li id="upcomingWrap" class="upcoming-list-col3">
            <h4>Coming Up</h4>

            <ul id="upcoming">
              <li>
                <a href="/sportsdetail">
                  <span class="time">14:00</span>
                  Pakenham (AUS)
                </a>
              </li>

              <li>
                <a href="/sportsdetail">
                  <span class="time">17:05</span>Kenilworth(RSA)
                </a>
              </li>
              <li>
                <a href="/sportsdetail">
                  <span class="time">17:20</span>Lingfield22nd
                </a>
              </li>
              <li>
                <a href="/sportsdetail">
                  <span class="time">17:20</span>Lingfield(RFC)
                </a>
              </li>
              <li>
                <a href="/sportsdetail">
                  <span class="time">17:24</span>Bendigo(AUS)
                </a>
              </li>
              <li>
                <a href="/sportsdetail">
                  <span class="time">17:35</span>Kenilworth(RSA)
                </a>
              </li>
            </ul>
          </li>
        </ul> */}
      </div>
    </>
    </LayoutComponent>
  );
}

export default Sports;